import { Injectable } from "@angular/core";
import { FixtureDto } from "app/models";
import { FixtureFullDto } from "app/models/dtos/fixture-full.dto";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BaseService } from "./base.service";

@Injectable()
export class FixtureService extends BaseService {
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    getNextOpponent(): Observable<FixtureDto> {
        return this.httpService.get<FixtureDto>(this.apiUrl + 'fixtures/next', null)
    }

    getNationalNextOpponent(): Observable<FixtureDto> {
        return this.httpService.get<FixtureDto>(this.apiUrl + 'fixtures/national/next', null)
    }

    getNextOpponentWithDetails(): Observable<FixtureFullDto> {
        return this.httpService.get<FixtureFullDto>(this.apiUrl + 'fixtures/next-details', null)
    }

    getNationalNextOpponentWithDetails(): Observable<FixtureFullDto> {
        return this.httpService.get<FixtureFullDto>(this.apiUrl + 'fixtures/national/next-details', null)
    }
}